import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/down.svg";
var DownSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DownSolid_default as default
};
